import { component } from 'picoapp';
import { getCart } from 'utils/cart';
import { handleizeString } from 'utils/string';
import { clear } from 'utils/node';

export default component((node, ctx) => {
  const form = node.querySelector('[data-item-form]');

  const buildInputs = (group) => {
    let html = '';
    const variants = JSON.parse(group.dataset.variants);

    variants.forEach((item) => {
      html += String.raw`
        <label for="${handleizeString(item.id)}"
          class="product-item__form-item">

          <input id="${handleizeString(item.id)}"
            name="id"
            type="radio"
            value="${item.variant.id}"
            data-quickbuy-variant
            ${!item.variant.available ? 'disabled' : ''}>
          <span class="product-item__form-item-title btn ${!item.variant.available ? 'is-disabled' : ''}">${item.title}</span>
        </label>
      `;
    });

    clear(group);
    group.insertAdjacentHTML('beforeend', html);
  };

  const quickbuy = () => {
    const defaultVariantGroup = form.querySelector('[data-gender]:not(.hidden)');
    const trigger = node.querySelector('[data-trigger-form]');
    const switches = form.querySelectorAll('[data-switch]');
    const variantGroups = form.querySelectorAll('[data-gender]');
    const inputs = form.querySelectorAll('input[name="id"]');

    // Toggle form
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      buildInputs(defaultVariantGroup);
      node.classList.toggle('form-open');
    });

    switches.forEach((item) => {
      const { switch: gender } = item.dataset;
      const variantGroup = form.querySelector(`[data-gender="${gender}"]`);

      item.addEventListener('click', (e) => {
        e.preventDefault();

        buildInputs(variantGroup);

        variantGroups.forEach((group) => group.classList.add('hidden'));
        variantGroup.classList.remove('hidden');

        switches.forEach((el) => el.classList.remove('is-active'));
        item.classList.add('is-active');

        inputs.forEach((input) => {
          input.checked = false;
        });
      });
    });

    ctx.on('cart:updated', () => {
      node.classList.remove('form-open');
      inputs.forEach((input) => {
        input.checked = false;
      });

      setTimeout(() => node.classList.remove('form-product-added'), 1500);
    });
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const response = await fetch(`${form.action}.js`, {
      method: form.method,
      body: new FormData(form),
    });

    node.classList.add('form-product-added');

    const data = await getCart();
    ctx.emit('cart:updated', { cart: data });

    document.dispatchEvent(new CustomEvent('product:added', {
      detail: { data: response },
    }));
  };

  if (form) {
    quickbuy();
    form.addEventListener('change', submitHandler);
  }
});
